import { Category } from './category';
import { ShippingRange } from './shipping';

export interface Product {
  id: number;
  productDisplayName: string;
  productUrl: string;
  price: number;
  originalPrice: number;
  summary?: string;
  infoText?: string;
  primaryCategoryId: number;
  categories: Category[];
  minCount: number;
  primaryImageUrl?: string;
  imageUrls?: string[];
  altPriceText?: string;
  hasModules?: boolean;
  lineId?: number;
  forSale: boolean;
  notForSaleLabel: string;
  splash?: boolean;
  quickCompositePurchase?: boolean;
  isAdvertisement?: boolean;
  allergens: Allergens[];
  shippings: ProductShipping[];
  productDeliveryLimit: DeliveryLimit;
  alcoholPercent: number;
  badgeUrl?: string;
  priority?: number;
  productCategoryTag?: GetProductCategoryTags;
  productCategoryTagId?: number;
  productCategoryTags: number[];
  productPageButtonText?: string;
  ingredients?: string;
  nutrients?: Nutrient[];
  packageOptions?: ProductPackageOption[];
  descriptionExtensions?: DescriptionExtension[];
  productCardDescription?: string;
}

export interface ProductPackageOption {
  id: number;
  packageSize: number;
  packageNumber: string;

  amount?: number;
}

export interface ProductDetails extends Product {
  productDisplayTitle: string;
  productPageTitle: string;
  productPageDescription: string;
  productDescription: string;
  productDetailsModel?: any;
  productSalesAvailabilityModel?: any;
  productModules: ProductModule[];
  productAdditions: ProductAdditions[];
  pdfUrls: string[];
  displayPdfUrls: boolean;
  discountLevels: discountLevels[];
  productType: ProductTypes;
  onlineProductLinksName: string;
  onlineProductLinks: OnlineProductLinks[];
  onlineImageStyle: OnlineImageStyle;
  hidden: boolean;
  notForSaleDescription: string;
  backgroundImageUrl: string;
  backgroundImageDarken: boolean;
}

export interface ProductModuleProduct extends Product {
  productMinPickCount: number | null;
  productMaxPickCount: number | null;
}

export interface ProductModule {
  id: number;
  name: string;
  isProductSetup: boolean;
  minPickCount: number;
  maxPickCount?: number;
  singles: boolean;
  main: boolean;
  showMainTitle: boolean;
  pictureCards: boolean;
  products: ProductModuleProduct[];
}

export interface ProductAdditions {
  id: number;
  name: string;
  display: boolean;
  carousel: boolean;
  products: ProductDetails[];
}

export interface ProductComposition extends ProductDetails {
  moduleChoices: Record<number, ModuleChoice>;
}

export interface ModuleChoice {
  name: string;
  products: Record<number, CompositionChild>;
}

export interface CompositionChild extends Product {
  moduleParentName?: string;
  quantity: number;
}

export interface DeliveryLimit {
  id: number;
  label: string;
  intervals: ShippingRange[];
  hidden: boolean;
}

export interface Nutrient {
  name: string;
  unit: string;
  value: string;
}

export type Params = Record<string, string | number | boolean | readonly (string | number | boolean)[]>;
export interface ProductPageRequest extends Params {
  MerchantId: number;
  PageSize: number;
  PageNumber: number;
  SearchTerm?: string;
  CategoryIds?: number[];
  DisplayInStore: boolean;
  CustomerId?: number;
}

export interface ProductPageResponse {
  total: number;
  products: Product[];
}

export interface Saving {
  label: string;
  price: number;
  quantity?: number;
}

export interface discountLevels {
  id: number;
  discountPercent: number;
  minimumQuantity: number;
  displayText: string;
  hidePercentPerQuantity: boolean;
  includeModuleProducts: boolean;
}

// Used for max quantity explainations
export const QUANTITY_KEY = '{quantity}';
export const PRICE_KEY = '{price}';

export const CATEGORY_ID = 'categoryId';
export interface ProductFilter {
  categoryId?: string;
}

export interface ProductShipping {
  name: string;
  shippingId: number;
}

export interface GetProductCategoryTags {
  id: number;
  name: string;
  color: string;
  icon: string;
  showFrontend: boolean;
}

export enum Allergens {
  GLUTENHOLDIGE,
  KREBSDYR,
  AEG,
  FISK,
  JORDNOEDDER,
  SOJA,
  MAELK,
  NOEDDER,
  SELLERI,
  SENNEP,
  SESAMFROE,
  SVOVLDIOXID,
  LUPIN,
  BLOEDDYR,
}

export const AllergensNames = [
  'Glutenholdige',
  'Krebsdyr',
  'Æg',
  'Fisk',
  'Jordnødder',
  'Soja',
  'Mælk',
  'Nødder',
  'Selleri',
  'Sennep',
  'Sesamfrø',
  'Svovldioxid',
  'Lupin',
  'Bløddyr',
];

export enum ProductTypes {
  Catering = 0,
  Online = 1,
}

export interface OnlineProductLinks {
  id: number;
  productId: number;
  productUrl: string;
  displayPriority: number;
  name: string;
}

export enum OnlineImageStyle {
  One,
  Two,
  Five,
}

export const OnlineImageClass = ['one-image', 'two-images', 'five-images'];

export interface DescriptionExtension {
  index: number;
  title: string;
  content: string;
  icon: string;
}
